module.exports = __webpack_public_path__ + "img/neotag_unit_cyan-01.56efecac.svg";